// extracted by mini-css-extract-plugin
var _1 = "kY2XG";
var _2 = "a7GJz";
export { _1 as "base", _2 as "inline" }
